import { render, staticRenderFns } from "./car-info-select.vue?vue&type=template&id=52749340&scoped=true&"
import script from "./car-info-select.vue?vue&type=script&lang=ts&"
export * from "./car-info-select.vue?vue&type=script&lang=ts&"
import style0 from "./car-info-select.vue?vue&type=style&index=0&id=52749340&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52749340",
  null
  
)

export default component.exports